import validator from "validator";
import message from "../../../messages/categories-site-publishers";

const validateName = (name) => {
  if (validator.isEmpty(name)) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  if (!name.trim().length) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  return true;
};

const validateFormPermisson = (info) => {
  const resValidateName = validateName(info.name);
  if (resValidateName != true) {
    return resValidateName;
  }

  return true;
};

export default validateFormPermisson;
